/* Error404Page auto-generated by npm run generator */
import { Button, makeStyles, Theme } from "@material-ui/core"
import { observer } from "mobx-react"
import React from "react"
import { useHistory } from "react-router-dom"
import { PATHS } from "Router"
import { useRootClasses } from "style"

interface Error404PageProps {}

const useStyles = makeStyles((theme: Theme) => ({
    error404PagePage: {
        backgroundColor: theme.palette.background.default,
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        justifyContent: "center",
        flexGrow: 1,
        padding: theme.spacing(2),
    },
}))

const Error404Page: React.FC<Error404PageProps> = (props) => {
    const history = useHistory()
    const classes = useStyles()
    const rc = useRootClasses()

    return (
        <div className={classes.error404PagePage}>
            <h6 className={rc.m0}>Whoops, looks like there is nothing here.</h6>
            <Button variant="contained" color="primary" onClick={() => history.push(PATHS.HOME())}>
                Home
            </Button>
        </div>
    )
}

export default observer(Error404Page)
